module.exports = __webpack_public_path__ + "static/media/fernanda.68140cf1.jpg";